import { graphql } from '@/generated/gql';

export const USER_PROFILE_QUERY = graphql(/* GraphQL */ `
  query UserProfile($userId: UUID) {
    astronaut {
      user(id: $userId) {
        id
        primarySourceReference
        profile {
          id
          firstName
          lastName
          email
          capabilityIds
          commodityGroupIds
          organizationId
          deliveryLocationId
          accountingAreaId
          costCenterId
          currency
          workingHours
          jobTitle
          pictureId
          updatedAt
          createdAt
          language
        }
      }
    }
  }
`);
